import React from "react";
import { Table } from "antd";
import PlanningCell from "./PlanningCell";
import MonthlyTableWrapper from "./MonthlyTable.style";
const MonthlyPlanningTable = (props) => {
  const { visits } = props;

  const columns = [
    {
      title: null,
      dataIndex: "patient",
      render(text, record) {
        return <PlanningCell record={record} index={visits.indexOf(record)} />;
      },
    },
  ];
  return (
    visits?.length > 0 && (
      <MonthlyTableWrapper>
        <Table
          // bordered
          columns={columns}
          dataSource={visits}
          rowKey={(record) => record.id}
          pagination={false}
        />
      </MonthlyTableWrapper>
    )
  );
};

export default MonthlyPlanningTable;
